// src/views/poc/operacional/processos/processosFluxo.js

export const TIPOS_PROCESSO = [
  'AUTO DE INTIMAÇÃO',
  'AUTO DE INFRAÇÃO',
  'MULTA',
  'ADVERTÊNCIA',
  'INTERDIÇÃO',
  'DESINTERDIÇÃO',
  'SUSPENSÃO',
  'APREENSÃO',
  'FIEL DEPOSITÁRIO',
  'DOAÇÃO'
]

export const FLUXOS_PADRAO = {
  'AUTO DE INTIMAÇÃO': [
    'ABERTURA',
    'EMISSÃO DO AUTO',
    'CIÊNCIA DO ESTABELECIMENTO',
    'PRAZO PARA ADEQUAÇÃO',
    'VISTORIA DE RETORNO',
    'CUMPRIDO',
    'ENCERRAMENTO'
  ],

  'AUTO DE INFRAÇÃO': [
    'ABERTURA',
    'EMISSÃO DO AUTO',
    'CIÊNCIA DO ESTABELECIMENTO',
    'PRAZO PARA DEFESA',
    'ANÁLISE DA DEFESA',
    'JULGAMENTO',
    'PENALIDADE APLICADA',
    'ENCERRAMENTO'
  ],

  'MULTA': [
    'ABERTURA',
    'LANÇAMENTO DA MULTA',
    'NOTIFICAÇÃO',
    'PRAZO PARA RECURSO',
    'JULGAMENTO DO RECURSO',
    'PAGAMENTO',
    'ENCERRAMENTO'
  ],

  'ADVERTÊNCIA': [
    'ABERTURA',
    'EMISSÃO DA ADVERTÊNCIA',
    'CIÊNCIA DO ESTABELECIMENTO',
    'PRAZO PARA ADEQUAÇÃO',
    'VERIFICAÇÃO',
    'ENCERRAMENTO'
  ],

  'INTERDIÇÃO': [
    'ABERTURA',
    'DECISÃO DE INTERDIÇÃO',
    'CIÊNCIA DO ESTABELECIMENTO',
    'BLOQUEIO DAS ATIVIDADES',
    'ADEQUAÇÕES',
    'VISTORIA PARA DESINTERDIÇÃO',
    'ENCERRAMENTO'
  ],

  'DESINTERDIÇÃO': [
    'ABERTURA',
    'SOLICITAÇÃO DE DESINTERDIÇÃO',
    'ANÁLISE DOCUMENTAL',
    'VISTORIA',
    'DECISÃO',
    'LIBERAÇÃO',
    'ENCERRAMENTO'
  ],

  'SUSPENSÃO': [
    'ABERTURA',
    'DECISÃO DE SUSPENSÃO',
    'NOTIFICAÇÃO',
    'PRAZO PARA REGULARIZAÇÃO',
    'REAVALIAÇÃO',
    'ENCERRAMENTO'
  ],

  'APREENSÃO': [
    'ABERTURA',
    'LAVRATURA DA APREENSÃO',
    'IDENTIFICAÇÃO DOS ITENS',
    'DESTINAÇÃO',
    'ENCERRAMENTO'
  ],

  'FIEL DEPOSITÁRIO': [
    'ABERTURA',
    'NOMEAÇÃO DO FIEL DEPOSITÁRIO',
    'TERMO DE RESPONSABILIDADE',
    'ACOMPANHAMENTO',
    'BAIXA',
    'ENCERRAMENTO'
  ],

  'DOAÇÃO': [
    'ABERTURA',
    'AVALIAÇÃO DOS ITENS',
    'AUTORIZAÇÃO',
    'REGISTRO DA DOAÇÃO',
    'COMPROVAÇÃO DE DESTINO',
    'ENCERRAMENTO'
  ]
}

export function obterProximosAndamentos(tipo, historico = []) {
  const fluxo = FLUXOS_PADRAO[tipo] || []
  const realizados = historico.map(h => h.andamento)
  return fluxo.filter(item => !realizados.includes(item))
}

export function obterFaseAtual(tipo, historico = []) {
  if (!historico.length) return 'NÃO INICIADO'
  return historico[historico.length - 1]?.andamento || 'NÃO INICIADO'
}